var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeakerMinimumRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.7041 3.44103C14.8952 3.66674 15 3.95286 15 4.24856V19.7502C15 20.4405 14.4404 21.0002 13.75 21.0002C13.4542 21.0002 13.168 20.8953 12.9423 20.7042L7.97513 16.4984H4.25C3.00736 16.4984 2 15.491 2 14.2484V9.74839C2 8.50575 3.00736 7.49839 4.25 7.49839H7.97522L12.9425 3.29442C13.4694 2.84843 14.2582 2.91407 14.7041 3.44103ZM13.5 4.78766L8.52478 8.99839H4.25C3.83579 8.99839 3.5 9.33418 3.5 9.74839V14.2484C3.5 14.6626 3.83579 14.9984 4.25 14.9984H8.52487L13.5 19.2109V4.78766Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeakerMinimumRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speaker-minimum-regular.161c635a.svg";
export { ForwardRef as ReactComponent };